/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Copy_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Copy activation code" |
*
* @param {Offline_Activation_Copy_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_copy_aria_label = /** @type {((inputs?: Offline_Activation_Copy_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Copy_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le code d'activation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivierungscode kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia il codice di attivazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать код активации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar código de activación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制激活码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーションコードをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्टिवेशन कोड कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar código de ativação")
	return /** @type {LocalizedString} */ ("Copy activation code")
});